export var PUBLIC_CSS_URL = 'https://patterns.boston.gov/css/public.css'; // export const PUBLIC_CSS_URL = 'https://patterns-stg.boston.gov/css/public.css';
// export const PUBLIC_CSS_URL = 'http://localhost:3030/css/public.css';

export var WHITE = '#fff';
export var BLACK = '#000';
export var YELLOW = '#fcb61a';
export var GREEN = '#62A744';
export var GRAY_000 = '#f3f3f3';
export var GRAY_100 = '#e0e0e0';
export var GRAY_200 = '#C8C8C8';
export var GRAY_300 = '#828282';
export var GRAY_400 = '#d2d2d2';
export var CHARLES_BLUE = '#091f2f';
export var PURPLE = '#681da8'; // 2/2019: DARK variations of OPTIMISTIC_BLUE and FREEDOM_RED have been added
// to provide stronger contrast and readability as text on a light background.
// The original colors have been renamed as the LIGHT variants.
// LIGHT should always be used for text links on Charles Blue or black. It’s
// also the preferred variant for some elements’ hover background color, and can
// also be used in decorative cases.
//
// DARK should always be used for text on white or GRAY_000.

export var OPTIMISTIC_BLUE_LIGHT = '#288be4';
export var OPTIMISTIC_BLUE_DARK = '#1871bd';
export var FREEDOM_RED_LIGHT = '#fb4d42';
export var FREEDOM_RED_DARK = '#d22d23';
export var DEFAULT_TEXT = '#58585b';
export var FOCUS_INDICATOR_COLOR = OPTIMISTIC_BLUE_LIGHT;
export var ERROR_BORDER_COLOR = FREEDOM_RED_LIGHT;
export var ERROR_TEXT_COLOR = FREEDOM_RED_DARK;
export var LORA_SRC = 'https://patterns.boston.gov/fonts/lora/lora-regular-webfont.woff2';
export var MONTSERRAT_SRC = 'https://patterns.boston.gov/fonts/montserrat/montserrat-regular-webfont.woff2';
export var SANS = 'Montserrat, Arial, sans-serif';
export var SERIF = 'Lora, Georgia, serif';
export var MEDIA_X_SMALL = '@media screen and (max-width: 330px)';
export var MEDIA_SMALL = '@media screen and (min-width: 480px)';
export var MEDIA_SMALL_MAX = '@media screen and (max-width: 480px)';
export var MEDIA_MEDIUM = '@media screen and (min-width: 768px)';
export var MEDIA_MEDIUM_MAX = '@media screen and (max-width: 768px)';
export var MEDIA_LARGE = '@media screen and (min-width: 840px)';
export var MEDIA_LARGE_MAX = '@media screen and (max-width: 840px)';
export var MEDIA_X_LARGE = '@media screen and (min-width: 980px)';
export var MEDIA_XX_LARGE = '@media screen and (min-width: 1280px)';
export var MEDIA_PRINT = '@media print';
export var HEADER_HEIGHT = 119;
export var IPHONE_FOOTER_HEIGHT = 64;